import { useNavigate } from "react-router-dom";
import { FetchProjectsResponse } from "../../../types/apiResponsesTypes";
import { ProjectPartial } from "../../../types/projects";
import GenericTable from "../GenericTable";
import useTableProjects from "./hooks/useTableProjects";

type Props = {
  data: FetchProjectsResponse | undefined;
  fetchData: (queryParams?: string) => void;
  isLoading: boolean;
};

const TableProjects: React.FC<Props> = ({ data, fetchData, isLoading }) => {
  const navigate = useNavigate();
  const { columns, onRowClick } = useTableProjects({ navigate });

  return (
    <GenericTable<ProjectPartial>
      results={data?.results || []}
      count={data?.count || 0}
      columns={columns}
      fetchData={fetchData}
      isLoading={isLoading}
      onRow={onRowClick}
    />
  );
};

export default TableProjects;
